// src/components/Notepad.js
import React, { useState, useEffect } from "react";

export default function Notepad({ isOpen, onClose }) {
  const [content, setContent] = useState("");

  // Load notes on mount OR when the drawer opens
  useEffect(() => {
    if (isOpen) {
      const saved = localStorage.getItem("exam_notes") || "";
      setContent(saved);
    }
  }, [isOpen]);

  // Persistence: Save on every change
  const handleChange = (e) => {
    const val = e.target.value;
    setContent(val);
    localStorage.setItem("exam_notes", val);
  };

  const handleClear = () => {
    setContent("");
    localStorage.setItem("exam_notes", "");
  };

  return (
    <>
      <div className={`notepad-drawer ${isOpen ? "open" : ""}`}>
        <div className="notepad-header">
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ fontSize: 18 }}>📝</span>
            <span style={{ fontWeight: 700, fontSize: 13, letterSpacing: "-0.01em" }}>Personal Notes</span>
          </div>
          <button className="notepad-close" onClick={onClose}>✕</button>
        </div>

        <div className="notepad-body">
          <textarea
            className="notepad-textarea"
            placeholder="Type your notes here... (auto-saves)"
            value={content}
            onChange={handleChange}
          ></textarea>
        </div>

        <div className="notepad-footer">
          <button className="clear-btn" onClick={handleClear}>Clear Area</button>
          <span style={{ fontSize: 10, color: "var(--text-muted)" }}>Data saved locally</span>
        </div>
      </div>
    </>
  );
}
